var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeviceWithChildren = function SvgDeviceWithChildren(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "#FFC4BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 26,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "#FFC4BF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 26,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "#FFC4BF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.25,
    y: 26,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "#FFC4BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 20V26H27.25V20H44.25C44.8023 20 45.25 20.4477 45.25 21V26H47.25V21C47.25 19.3431 45.9069 18 44.25 18H27.25V12H25.25V18H8.25C6.59315 18 5.25 19.3431 5.25 21V26H7.25V21C7.25 20.4477 7.69772 20 8.25 20H25.25Z",
    fill: "#E0E0E0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeviceWithChildren);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "device-with-children.366ad45357d7f5b8fc0371873e900fd6.svg";